import { useContext, useEffect, useState } from 'react';
import clienteAxios from '../../config/axios';
import AuthContext from '../../context/autenticacion/authContext.js';
import ModalNuevaCuenta from '../../components/Modales/ModalNuevaCuenta';
import ModalNuevaWallet from '../../components/Modales/ModalNuevaWallet';
import { useT } from 'i18n';

const enmascarar = (n) => {
  const s = String(n || '');
  return s.length > 4 ? `•••• ${s.slice(-4)}` : s;
};

const Seccion = ({ titulo, ayuda, cuentas, vacio, onAgregar, onBorrar, borrando, wallet, ancha }) => {
  const { t } = useT();
  return (
  <section className={`p7-cuentas-sec${ancha ? ' p7-cuentas-ancha' : ''}`}>
    <header>
      <div>
        <h3>{titulo}</h3>
        <p>{ayuda}</p>
      </div>
      <button type="button" className="p7-btn-gold" onClick={onAgregar}>{wallet ? t('cuenta.anadirWallet') : t('cuenta.anadirCuenta')}</button>
    </header>

    {cuentas.length === 0 ? (
      <div className="p7-empty">
        <p>{vacio}</p>
        <button type="button" className="p7-btn-ghost" onClick={onAgregar}>{wallet ? t('cuenta.anadirPrimeraWallet') : t('cuenta.anadirPrimera')}</button>
      </div>
    ) : (
      <ul className="p7-cuentas-lista">
        {cuentas.map((c) => (
          <li key={c.id}>
            <div className="p7-cuenta-main">
              <strong>{wallet ? c.bank_client : (c.bank_name || t('cuenta.banco'))}</strong>
              <span>{wallet ? 'Wallet USDT' : c.bank_client}</span>
            </div>
            <div className="p7-cuenta-meta">
              {wallet ? (
                <>
                  <span className="p7-chip">{c.network || 'USDT'}</span>
                  <code title={c.address_cripto}>{c.address_cripto ? `${c.address_cripto.slice(0, 8)}…${c.address_cripto.slice(-6)}` : '—'}</code>
                </>
              ) : (
                <>
                  <span className="p7-chip">{c.bank_type || t('cuenta.cuentaTipo')}</span>
                  <code>{enmascarar(c.bank_account)}</code>
                  {c.bank_swift ? <small>SWIFT {c.bank_swift}</small> : null}
                  {c.pais ? <small>{c.pais}</small> : null}
                </>
              )}
            </div>
            <button type="button" className="p7-cuenta-borrar" disabled={borrando === c.id} onClick={() => onBorrar(c)} aria-label={t('cuenta.eliminarNombre', { nombre: c.bank_name || c.bank_client })}>
              {borrando === c.id ? t('cuenta.eliminando') : t('cuenta.eliminar')}
            </button>
          </li>
        ))}
      </ul>
    )}
  </section>
  );
};

const CuentasBancarias = () => {
  const { t, ts } = useT();
  const { cuentas_internacionales, cuentas_nacionales, cuentas_remesas, ListaNacionales, ListaInternacionales, ListaRemesas } = useContext(AuthContext);
  const [modal, setModal] = useState(null); // 'nacional' | 'internacional' | null
  const [borrando, setBorrando] = useState(null);
  const [aviso, setAviso] = useState('');

  useEffect(() => {
    window.scrollTo(0, 0);
    ListaNacionales && ListaNacionales();
    ListaInternacionales && ListaInternacionales();
    ListaRemesas && ListaRemesas();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const recargar = () => {
    ListaNacionales && ListaNacionales();
    ListaInternacionales && ListaInternacionales();
    ListaRemesas && ListaRemesas();
  };

  const guardada = () => {
    setModal(null);
    setAviso(t('cuenta.cuentaGuardada'));
    recargar();
  };

  const borrar = async (c) => {
    if (!window.confirm(t('cuenta.confirmarEliminar', { nombre: c.bank_name || c.bank_client }))) return;
    setBorrando(c.id);
    try {
      await clienteAxios.post(`/api/client/beneficiario_delete/${c.id}`);
      setAviso(t('cuenta.cuentaEliminada'));
      recargar();
    } catch (e) {
      setAviso(ts(e.response?.data?.message) || t('cuenta.noSeEliminoCuenta'));
    } finally {
      setBorrando(null);
    }
  };

  return (
    <div className="p7-cuentas">
      {aviso && <div className="p7-cuentas-aviso" role="status" onClick={() => setAviso('')}>{aviso}</div>}

      <Seccion
        ancha
        wallet
        titulo={t('cuenta.walletsTitulo')}
        ayuda={t('cuenta.walletsAyuda')}
        cuentas={cuentas_remesas || []}
        vacio={t('cuenta.walletsVacio')}
        onAgregar={() => { setAviso(''); setModal('wallet'); }}
        onBorrar={borrar}
        borrando={borrando}
      />
      <Seccion
        titulo={t('cuenta.panamaTitulo')}
        ayuda={t('cuenta.panamaAyuda')}
        cuentas={cuentas_nacionales || []}
        vacio={t('cuenta.panamaVacio')}
        onAgregar={() => { setAviso(''); setModal('nacional'); }}
        onBorrar={borrar}
        borrando={borrando}
      />
      <Seccion
        titulo={t('cuenta.internacionalesTitulo')}
        ayuda={t('cuenta.internacionalesAyuda')}
        cuentas={cuentas_internacionales || []}
        vacio={t('cuenta.internacionalesVacio')}
        onAgregar={() => { setAviso(''); setModal('internacional'); }}
        onBorrar={borrar}
        borrando={borrando}
      />

      <ModalNuevaWallet abierto={modal === 'wallet'} onCerrar={() => setModal(null)} onGuardada={guardada} />
      <ModalNuevaCuenta abierto={modal === 'nacional' || modal === 'internacional'} tipo={modal === 'internacional' ? 'internacional' : 'nacional'} onCerrar={() => setModal(null)} onGuardada={guardada} />
    </div>
  );
};

export default CuentasBancarias;
